module.exports = __webpack_public_path__ + "static/media/ellipsis-v-alt.28fe8611.svg";